import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { RouterProvider } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { AlertMessageContext } from "./contexts/alert/AlertMessageContext";
import { AlertMessage } from "@contexts/alert/AlertMessage";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance } from "./config/auth";
import { router } from "@features/shared/routes/routes";
import { queryClient } from "@config/react-query";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <QueryClientProvider client={queryClient}>
        <AlertMessageContext>
          <RouterProvider router={router} />
          <AlertMessage />
        </AlertMessageContext>
      </QueryClientProvider>
    </MsalProvider>
  </React.StrictMode>
);
